/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2221 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { sharedMyAccountDetailsLinesStyles } from "@monsma/App/ComponentExtensions/OrderLinesListExtension";
import { cartLineCardExpandedStyles } from "@monsma/Overrides/Components/CartLineCardExpanded";
import { css } from "styled-components";

cartLineCardExpandedStyles!.xCartLine = {
    cartLineLabel: sharedMyAccountDetailsLinesStyles.orderLineLabel,
    cartLineText: sharedMyAccountDetailsLinesStyles.orderLineText,
    productPrice: {
        priceLabelText: {
            css: css`
                display: block;
            `,
        },
    },
    sectionWrapper: {
        css: css`
            margin-top: 10px;
        `,
    },
};

cartLineCardExpandedStyles.subtotalWithoutVatText = {
    ...sharedMyAccountDetailsLinesStyles.smallHeadingAndTextContent,
    wrapper: {
        css: css`
            margin-top: 10px;
        `,
    },
};

cartLineCardExpandedStyles.vatAmount = cartLineCardExpandedStyles.subtotalWithoutVatText;

cartLineCardExpandedStyles.extendedUnitNetPrice = cartLineCardExpandedStyles.subtotalWithoutVatText;
